import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';

import { hardReload } from 'utils/index';
import { routeHasProp } from 'services/navigation-service';

import bruceLee from '../images/quotes/bruce-lee@2x.png';
import anneFrank from '../images/quotes/anne-frank@2x.png';
import picasso from '../images/quotes/picasso@2x.png';
import henryFord from '../images/quotes/henry-ford@2x.png';
import dalaiLama from '../images/quotes/dalai-lama@2x.png';
import spongebob from '../images/quotes/spongebob@2x.png';
import cohen from '../images/quotes/cohen@2x.png';
import quasimodo from '../images/quotes/quasimodo@2x.png';
import einstein from '../images/quotes/einstein@2x.png';
import daVinci from '../images/quotes/da-vinci@2x.png';
import peterBlock from '../images/quotes/peter-block@2x.png';

const QUOTES_COUNT = 11;
const randomQuoteIndex = Math.floor(Math.random() * QUOTES_COUNT);

class AppLoading extends PureComponent {
    static defaultProps = {
        showQuote: true
    };

    renderQuote(quote) {
        return (
            <div className="app-quote">
                <div className="app-quote-main">{quote.quote}</div>

                <div className="app-quote-author">
                    <div className="author-avatar">
                        <img src={quote.authorImage} alt={quote.author} />
                    </div>

                    <div className="author-main">
                        <h5>{quote.author}</h5>
                        <h6>{quote.authorRole}</h6>
                    </div>
                </div>
            </div>
        )
    }

    get quotes() {
        const { t } = this.props;

        return [
            {
                quote: t('quotes.bruceLee.quote'),
                author: t('quotes.bruceLee.author'),
                authorRole: t('quotes.bruceLee.authorRole'),
                authorImage: bruceLee
            },
            {
                quote: t('quotes.anneFrang.quote'),
                author: t('quotes.anneFrang.author'),
                authorRole: t('quotes.anneFrang.authorRole'),
                authorImage: anneFrank
            },
            {
                quote: t('quotes.pabloPicasso.quote'),
                author: t('quotes.pabloPicasso.author'),
                authorRole: t('quotes.pabloPicasso.authorRole'),
                authorImage: picasso
            },
            {
                quote: t('quotes.henryFord.quote'),
                author: t('quotes.henryFord.author'),
                authorRole: t('quotes.henryFord.authorRole'),
                authorImage: henryFord
            },
            {
                quote: t('quotes.dalaiLama.quote'),
                author: t('quotes.dalaiLama.author'),
                authorRole: t('quotes.dalaiLama.authorRole'),
                authorImage: dalaiLama
            },
            {
                quote: t('quotes.spongeBob.quote'),
                author: t('quotes.spongeBob.author'),
                authorRole: t('quotes.spongeBob.authorRole'),
                authorImage: spongebob
            },
            {
                quote: t('quotes.leonardCohen.quote'),
                author: t('quotes.leonardCohen.author'),
                authorRole: t('quotes.leonardCohen.authorRole'),
                authorImage: cohen
            },
            {
                quote: t('quotes.quasimodo.quote'),
                author: t('quotes.quasimodo.author'),
                authorRole: t('quotes.quasimodo.authorRole'),
                authorImage: quasimodo
            },
            {
                quote: t('quotes.albertEinstein.quote'),
                author: t('quotes.albertEinstein.author'),
                authorRole: t('quotes.albertEinstein.authorRole'),
                authorImage: einstein
            },
            {
                quote: t('quotes.daVinci.quote'),
                author: t('quotes.daVinci.author'),
                authorRole: t('quotes.daVinci.authorRole'),
                authorImage: daVinci
            },
            {
                quote: t('quotes.peterBlock.quote'),
                author: t('quotes.peterBlock.author'),
                authorRole: t('quotes.peterBlock.authorRole'),
                authorImage: peterBlock
            }
        ];
    }

    get content() {
        const { t, i18n } = this.props;

        if (!i18n.translator.utils.hasLoadedNamespace('app-loading')) {
            return null;
        }

        if (this.props.location.pathname === '/dashboard-new') {
            return (
                <div className="app-loading-content">
                    <h4>{ t('creatingDashboard') }</h4>
                </div>
            );
        }

        if (this.props.location.pathname === '/psignup/theme') {
            return (
                <div className="app-loading-content">
                    <h4>{ t('creatingTeam') }</h4>
                </div>
            );
        }

        if (this.props.showQuote && !routeHasProp('withoutLoadingQuoute', this.props.location.pathname)) {
            return (
                <div className="app-loading-content">
                    { this.renderQuote(this.quotes[randomQuoteIndex]) }
                </div>
            );
        }

        return null;
    }

    componentDidMount() {
        this.timeoutTimer = setTimeout(() => {
            hardReload();
        }, [this.props.timeout]);
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutTimer);
    }

    render() {
        return (
            <div className="app-loading">
                <div className="app-loading-loader">
                    <span className="loader-dot" />
                    <span className="loader-dot" />
                    <span className="loader-dot" />
                </div>

                { this.content }
            </div>
        )
    }
}

export default withRouter(withTranslation('app-loading')(AppLoading));
